(() => {
  if (window.__orelaContentSectionsLoaded) return;
  window.__orelaContentSectionsLoaded = true;

  const CAROUSEL_SELECTOR = '[data-orela-carousel]';

  const setupCarousel = (root) => {
    if (!root || root.dataset.orelaCarouselReady === 'true') return;

    const track = root.querySelector('[data-orela-carousel-track]');
    const previous = root.querySelector('[data-orela-carousel-previous]');
    const next = root.querySelector('[data-orela-carousel-next]');
    const progress = root.querySelector('[data-orela-carousel-progress]');
    if (!track) return;

    root.dataset.orelaCarouselReady = 'true';

    track.scrollLeft = 0;

    const cards = () => Array.from(track.children).filter((child) => child.getClientRects().length > 0);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cardStep = () => {
      const card = cards()[0];
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
    };

    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = maximum > 2;
      const visibleRatio = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
      const travelledRatio = maximum ? Math.min(1, Math.max(0, track.scrollLeft / maximum)) : 0;

      if (previous) previous.hidden = !canScroll;
      if (next) next.hidden = !canScroll;
      if (progress) {
        progress.style.width = `${visibleRatio * 100}%`;
        progress.style.transform = `translateX(${travelledRatio * ((1 - visibleRatio) / visibleRatio) * 100}%)`;
      }
    };

    const move = (direction) => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const step = cardStep();
      const atStart = track.scrollLeft <= 8;
      const atEnd = track.scrollLeft >= maximum - 8;
      let target;

      if (direction > 0) {
        target = atEnd ? 0 : Math.min(track.scrollLeft + step, maximum);
      } else {
        target = atStart ? maximum : Math.max(track.scrollLeft - step, 0);
      }

      track.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    window.addEventListener('load', () => {
      track.scrollLeft = 0;
      update();
    }, { once: true });
    update();
  };

  const setupWithin = (container = document) => {
    container.querySelectorAll(CAROUSEL_SELECTOR).forEach(setupCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupWithin());
  } else {
    setupWithin();
  }

  document.addEventListener('shopify:section:load', (event) => setupWithin(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const track = block?.closest('[data-orela-carousel]')?.querySelector('[data-orela-carousel-track]');
    if (track && block) block.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
